var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_247_45545)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.4093 6.07527V8.23389C8.4093 8.44831 8.32412 8.65394 8.17251 8.80556C8.02089 8.95718 7.81525 9.04236 7.60083 9.04236H1.94153C1.72711 9.04236 1.52147 8.95718 1.36985 8.80556C1.21823 8.65394 1.13306 8.44831 1.13306 8.23389V2.57458C1.13306 2.36016 1.21823 2.15453 1.36985 2.00291C1.52147 1.85129 1.72711 1.76611 1.94153 1.76611H4.10015",
    stroke: "#2FE5A7",
    strokeWidth: 0.808472,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.60083 0.957642L9.21777 2.57458L5.17542 6.61694H3.55847V5L7.60083 0.957642Z",
    stroke: "#2FE5A7",
    strokeWidth: 0.808472,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_247_45545"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.70166,
    height: 9.70166,
    fill: "white",
    transform: "translate(0.324585 0.14917)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.fb606062f93a955a3cf86392f6a171bf.svg";
export { ForwardRef as ReactComponent };